import React from 'react';

export default function BlockHeader({ text = '', content = null }) {
  return (
    <div className="block-header">
      <div className="block-header-text">{text}</div>
      <div className="block-header-content">
        {content}
      </div>
    </div>
  );
}
